import { Ikon as _Ikon } from '@studio/design-system/button';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { MouseEvent, ReactElement } from 'react';
import { twMerge } from 'cn';
import type { SettingsProps } from './types.js';

/** `<Settings>` icon button component. */
export const Settings = ({ className, onClick, ...props }: SettingsProps): ReactElement => {
  const handleClick = useLatestFn((event: MouseEvent<HTMLButtonElement>) => {
    // Stop propagation to prevent the `<Card>` from being selected.
    event.stopPropagation();

    // Call original `onClick` handler.
    onClick?.(event);
  });

  return (
    <_Ikon
      className={twMerge(
        'text-muted opacity-0 hover:bg-transparent focus-visible:opacity-100 group-hover:opacity-100 group-focus-visible:opacity-100',
        className
      )}
      onClick={handleClick}
      {...props}
    />
  );
};
